const referral = {
  title: 'Referral Rewards',
  subtitle:
    'Invite friends to create a new EasyHireAI account. Rewards are issued at your 1st, 3rd, and 5th qualified invite.',
  shareTitle: 'Share your referral link',
  shareDesc:
    'When a friend signs up through this link and returns successfully, it counts toward your progress.',
  copy: 'Copy link',
  copied: 'Link copied',
  copyFailed: 'Copy failed. Please copy it manually.',
  currentCount: 'Qualified invites',
  peopleUnit: 'people',
  nextReward: 'Next reward',
  completed: 'All reward milestones completed',
  programClosed: 'The referral program is currently closed. History remains available.',
  routeTitle: 'Tiered reward path',
  routeDesc: 'Rewards are issued automatically when qualified invites reach each milestone.',
  quickShare: 'Quick share',
  shareQrTitle: 'Share QR code',
  shareQrDesc:
    'Friends can scan the QR code to open your referral link, or you can copy the link directly.',
  qrAlt: 'Referral invite QR code',
  downloadQr: 'Download QR',
  copyCode: 'Copy code ({code})',
  membershipDays: 'Membership days',
  aiMatchPoints: 'AI Credits',
  contactPoints: 'Contact points',
  unlocked: 'Unlocked',
  inProgress: 'In progress',
  rewardIssued: 'Reward issued',
  rulesButton: 'Rules',
  rulesTitle: 'Referral rules',
  gotIt: 'Got it',
  tipTitle: 'Sharing tip',
  tipDesc:
    'Share the link with peers who hire frequently. Mention AI matching and contact credits for better conversion.',
  friendBenefitTitle: 'Your friend also benefits',
  friendBenefitDesc: 'New users who register through your link can start with trial benefits.',
  recordsHint: 'Latest invite and reward settlement records',
  currentProgress: 'Current progress: {current} / {total}',
  needMore: 'Invite {count} more to claim',
  rules: {
    rule1: '1. A qualified invite requires a new account created through your referral link.',
    rule2:
      '2. Rewards are issued automatically when cumulative qualified invites reach the configured milestones.',
    rule3: '3. Invalid or abusive registrations may be excluded from reward settlement.',
    rule4: '4. Historical invite and reward records remain visible when the program is closed.',
  },
  tierTitles: {
    starter: 'Starter reward',
    growth: 'Growth reward',
    ambassador: 'Ambassador reward',
  },
  tierTags: {
    starter: 'First step',
    growth: 'Popular referrer',
    ambassador: 'Top advocate',
  },
  rewardBundle: 'Membership +{days} days · AI Credits +{ai} · Contact points +{contact}',
  milestoneLabel: '{count} invites',
  inviteHistory: 'Invite History',
  rewardHistory: 'Reward History',
  emptyInvites: 'No qualified invites yet. Copy the link above to start sharing.',
  emptyRewards: 'No reward records yet. Rewards are issued at 1, 3, and 5 qualified invites.',
  invitedUser: 'Invited account',
  qualifiedAt: 'Qualified at',
  milestone: 'Milestone',
  reward: 'Reward',
  status: 'Status',
  rewarded: 'Rewarded',
  recorded: 'Recorded',
  retry: 'Retry',
  loading: 'Loading...',
  loadFailed: 'Failed to load referral data',
  inviteTitle: 'A friend invited you to try EasyHireAI',
  inviteDesc:
    'You have received a 7-day AI Agent trial membership. Sign up to try the AI recruiting workspace.',
  inviteCta: 'Sign up for EasyHireAI',
  inviteCtaAuthed: 'Confirm referral',
  inviteLoading: 'Preparing invite...',
  inviteAccepting: 'Confirming referral...',
  inviteAccepted: 'Referral confirmed',
  inviteRecorded: "Your signup was counted toward your friend's referral progress",
  inviteRewarded:
    'Starter tasks are available. Complete the AI recruiting flow to unlock more membership benefits.',
  inviteAlreadyAccepted: 'This account has already confirmed a referral',
  inviteInvalid: 'This invite link is unavailable or expired',
  inviteNetworkError: 'Network error. You can reopen this page later to retry.',
  goWorkbench: 'Go to Workbench',
  errorCodes: {
    referral_program_closed: 'The referral program is currently closed',
    referral_invalid_code: 'This invite link does not exist or has been disabled',
    referral_ticket_invalid: 'Invite ticket verification failed. Please reopen the invite link',
    referral_ticket_expired: 'Invite ticket expired. Please reopen the invite link',
    referral_old_user: 'Only new accounts created through this invite can be counted',
    referral_self_invite: 'You cannot invite yourself',
    referral_already_attributed: 'This account is already attributed to another referrer',
  },
}

export default referral
